// extracted by mini-css-extract-plugin
export var border = "_bv-b";
export var circle = "_bv-3";
export var circleInner = "_bv-5";
export var disabled = "_bv-1";
export var focused = "_bv-a";
export var md = "_bv-8";
export var radioButton = "_bv-0";
export var radioInput = "_bv-2";
export var selected = "_bv-9";
export var sm = "_bv-7";
export var text = "_bv-4";
export var xs = "_bv-6";